<div fxLayout="row" fxLayoutGap="10px">
    <div fxFlex="50px">
        <mat-progress-spinner color="accent"
                        mode="indeterminate"
                        [diameter]="spinnerSize"></mat-progress-spinner>
    </div>
    <div>
        <ng-content></ng-content>
    </div>
</div>